module.exports = __webpack_public_path__ + "img/2S.33c964ae.png";